module.exports = __webpack_public_path__ + "static/media/selected-macos.79951a97.png";